import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'text', 'link' ];
  export() {
    this.linkTarget.classList.add('text-muted');
    this.textTarget.innerText = "Exporting...";
  }
}
